/* globals ResponsiveUtil */
export default function() {
	var $scrollpoints = $('.js-scrollpoint-animation');
	if ($scrollpoints.length) {
		$scrollpoints.addClass('initialized').each(function () {
			var $scrollpoint = $(this);
			var animation = $scrollpoint.data('animation');
			var animationDelay = $scrollpoint.data('animation-delay');
			var animationDuration = $scrollpoint.data('animation-duration');

			$scrollpoint.css({'animation-delay': animationDelay, 'animation-duration': animationDuration});

			var offset = '80%';

			if (ResponsiveUtil.isToTablet()) {
				offset = '100%';
			};

			new Waypoint({
				element: this,
				handler: function (direction) {
					var $this = $(this.element);

					$this.addClass('animated ' + animation);
				},
				offset: offset
			})
		});
	}
};
